import { render, staticRenderFns } from "./RevenueCards.vue?vue&type=template&id=19ba6816&"
import script from "./RevenueCards.vue?vue&type=script&lang=js&"
export * from "./RevenueCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports